import { util } from 'echarts/core';
import { type ThemeParser } from '../../../core/theme';
import { normalizeToArray } from '../../../util/utils';
import { judgeIsDynamicBar } from '../series/dynamicBar';

function parseDynamicHistogramGrid(option: Parameters<ThemeParser>[0]) {
  option.grid = normalizeToArray(option.grid || {});
  option.grid = option.grid.map(grid => {
    return (
      grid || {
        left: 120,
        right: 64,
        height: 320
      }
    );
  });
}

export function parseGrid(option: Parameters<ThemeParser>[0]): ReturnType<ThemeParser> {
  const DEFAULT_GRID = {
    left: 32,
    right: 8,
    top: 66,
    bottom: 52
  };
  option.grid = normalizeToArray(option.grid || {});
  option.grid.forEach(el => util.merge(el, DEFAULT_GRID));
}

export function gridThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const option = args[0];
  const series = normalizeToArray(option.series);
  if (judgeIsDynamicBar(series)) {
    parseDynamicHistogramGrid(option);
  }
}
